const storageKeys = {
    SE_CONFIG_FINANCEFORMINPUT: 'se_config_financeFormInput',
};
export default storageKeys;
//# sourceMappingURL=storageKeys.js.map